import { PropsWithChildren, createContext, useCallback, useState } from 'react'

import { DocumentCategorySizeDto } from '@model/DocumentCategories'

import { useGuardedContext } from '@global/useGuardedContext'

import { useApiClient } from './ApiClient'
import { ClientApiClient } from './clientApi'

interface CategorySizesReadContextProps {
  categorySizes: DocumentCategorySizeDto[]
}

interface CategorySizesWriteContextProps {
  refreshCategorySizes: () => void
}

const CategorySizesReadContext = createContext<CategorySizesReadContextProps | undefined>(undefined)

CategorySizesReadContext.displayName = 'CategorySizesReadContext'

const CategorySizesWriteContext = createContext<CategorySizesWriteContextProps | undefined>(
  undefined
)

export function useCategorySizesReadContext(): CategorySizesReadContextProps {
  return useGuardedContext(CategorySizesReadContext)
}
export function useCategorySizesWriteContext(): CategorySizesWriteContextProps {
  return useGuardedContext(CategorySizesWriteContext)
}

export function CategorySizesContextProvider({ children }: PropsWithChildren) {
  const [categorySizesState, setCategorySizesState] = useState<DocumentCategorySizeDto[]>([])
  const apiClient = useApiClient(ClientApiClient)

  const refreshCategorySizes = useCallback(async () => {
    if (categorySizesState.length > 0) return

    const fresh = await apiClient.getAllDocumentCategories('en')
    setCategorySizesState(fresh)
  }, [categorySizesState])

  return (
    <CategorySizesReadContext.Provider value={{ categorySizes: categorySizesState }}>
      <CategorySizesWriteContext.Provider value={{ refreshCategorySizes }}>
        {children}
      </CategorySizesWriteContext.Provider>
    </CategorySizesReadContext.Provider>
  )
}
